import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const data = {
  labels: ["11 ก.พ.", "12 ก.พ.", "13 ก.พ.", "14 ก.พ.", "15 ก.พ.", "16 ก.พ."],
  datasets: [
    {
      label: "รายรับ",
      backgroundColor: "#00BB9F",
      borderColor: "#00BB9F",
      borderWidth: 1,
      hoverBackgroundColor: "rgba(0, 187, 159, 0.7)",
      hoverBorderColor: "#00BB9F",
      data: [2000, 2500, 3000, 3500, 3200, 4000],
    },
    {
      label: "รายจ่าย",
      backgroundColor: "#6CD8BF",
      borderColor: "#6CD8BF",
      borderWidth: 1,
      hoverBackgroundColor: "rgba(108, 216, 191, 0.7)",
      hoverBorderColor: "#6CD8BF",
      data: [1000, 1500, 1200, 1800, 2000, 1500],
    },
    {
      label: "กำไร",
      backgroundColor: "#B0EE93",
      borderColor: "#B0EE93",
      borderWidth: 1,
      hoverBackgroundColor: "rgba(176, 238, 147, 0.7)",
      hoverBorderColor: "#B0EE93",
      data: [1000, 1000, 1800, 1700, 1200, 2500],
    },
  ],
};

const SalesChart = ({ logs }) => {
  console.log({ logs });

  const chartData = {
    labels: logs?.map((log) => log.date),
    datasets: [
      {
        label: "รายรับ",
        backgroundColor: "#00BB9F",
        borderColor: "#00BB9F",
        borderWidth: 1,
        hoverBackgroundColor: "rgba(0, 187, 159, 0.7)",
        hoverBorderColor: "#00BB9F",
        data: logs?.map((log) => log.revenue),
      },
      {
        label: "รายจ่าย",
        backgroundColor: "#D32F2F",
        borderColor: "#D32F2F",
        borderWidth: 1,
        hoverBackgroundColor: "rgba(211, 47, 47, 0.7)",
        hoverBorderColor: "#D32F2F",
        data: logs?.map((log) => log.expenditure),
      },
      {
        label: "กำไร",
        backgroundColor: "#007AFF",
        borderColor: "#007AFF",
        borderWidth: 1,
        hoverBackgroundColor: "rgba(0, 123, 255, 0.7)",
        hoverBorderColor: "#007AFF",
        data: logs?.map((log) => log.profit),
      },
    ],
  };
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Bar
        data={chartData}
        options={{
          maintainAspectRatio: false,
          scales: {
            x: {
              stacked: false,
            },
            y: {
              stacked: false,
            },
          },
        }}
      />
    </div>
  );
};

export default SalesChart;
